site.headSearch = {
	init: function () {
		site.toggle.init('.searchToggle', 'div[id^=searchBox]', 'search', function() {
			$('.searchQ').focus();
		});
	}
};

//site.inits.push('site.headSearch.init()');
